module.exports = __webpack_public_path__ + "static/media/pencil.1f7af42a.svg";